import { type PlainEnvironment } from "@/queries/environment-queries";

export function getRepoUrl(environment: PlainEnvironment) {
    const cloneUrl = environment.status?.content?.git?.cloneUrl;
    if (cloneUrl) {
        return parseRepoUrl(cloneUrl);
    }

    for (const spec of environment.spec?.content?.initializer?.specs || []) {
        if (spec.spec.case === "contextUrl") {
            const contextUrl = spec.spec.value.url;
            if (contextUrl) {
                return parseRepoUrl(contextUrl);
            }
        }
        if (spec.spec.case === "git") {
            const remoteUri = spec.spec.value.remoteUri;
            if (remoteUri) {
                return parseRepoUrl(remoteUri);
            }
        }
    }
    return undefined;
}

export function parseRepoUrl(url: string) {
    try {
        const normalizedUrl = normalizeRepoUrl(url.toLocaleLowerCase());
        const { host, pathname, protocol } = new URL(normalizedUrl);
        const parts = pathname.split("/");
        const account = parts.slice(1, parts.length - 1).join("/");
        const repo = parts[parts.length - 1];
        const repoUrl = `${protocol}//${host}/${account}/${repo}`;
        return { repoUrl, account, repo };
    } catch (error) {
        console.log("Failed to parse repo url", JSON.stringify({ url, error }));
        return undefined;
    }
}

function normalizeRepoUrl(repoUrl: string) {
    let url = repoUrl.replace(/\.git$/, "");
    url = url.replace(/\/-\/.*/, ""); // gitlab
    url = url.replace(/\/pull\/.*/, ""); // github
    url = url.replace(/\/commit\/.*/, ""); // github
    return url;
}
